<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="margin-top-home">
        <span class="failure">{{ failureMessage }}</span>
        <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="2" cols-xl="2">
          <b-col>
            <div class="text-center">
              <h4 class="inline">EXP Ranking</h4>&nbsp;&nbsp;(Total riders: {{ usersPagination.count }})
            </div>
            <b-table :fields="usersTable" :items="users" responsive="sm">
              <template #cell(levelRank)="data">
                <b>{{ data.item.levelRank }}</b>
              </template>
              <template #cell(rider)="data">
                <router-link class="text-black" :to="{ name: 'Rider', params: { id: data.item.id }}">
                  <img v-if="data.item.stravaDetails.profile" :src="data.item.stravaDetails.profile" width="25px">
                  <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="25px">
                  <b class="margin-left">{{ data.item.stravaDetails.firstname }} {{ data.item.stravaDetails.lastname }}</b>
                </router-link>
              </template>
              <template #cell(level)="data">
                <b-badge pill variant="primary">{{ data.item.level }}</b-badge>
              </template>
              <template #cell(experiencePoints)="data">
                <b>{{ data.item.experiencePoints.total }}</b>
              </template>
            </b-table>
            <div class="center-align">
              <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getUserLevelRanking', 'usersPagination')"/>
                Page: {{ usersPagination.page }} / {{ usersPagination.totalPages }}
              <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getUserLevelRanking', 'usersPagination')"/>
            </div>
          </b-col>
          <b-col>
            <div class="text-center">
              <h4 class="inline">Race Points Ranking</h4>&nbsp;&nbsp;(Total riders: {{ usersPagination2.count }})
            </div>
            <b-table :fields="usersTable2" :items="users2" responsive="sm">
              <template #cell(leagueRank)="data">
                <b>{{ data.item.leagueRank }}</b>
              </template>
              <template #cell(rider)="data">
                <router-link class="text-black" :to="{ name: 'Rider', params: { id: data.item.id }}">
                  <img v-if="data.item.stravaDetails.profile" :src="data.item.stravaDetails.profile" width="25px">
                  <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="25px">
                  <b class="margin-left">{{ data.item.stravaDetails.firstname }} {{ data.item.stravaDetails.lastname }}</b>
                </router-link>
              </template>
              <template #cell(racePoints)="data">
                <b>{{ data.item.racePoints.total }}</b>
              </template>
            </b-table>
            <div class="center-align">
              <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getUserLeagueRanking', 'usersPagination2')"/>
                Page: {{ usersPagination2.page }} / {{ usersPagination2.totalPages }}
              <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getUserLeagueRanking', 'usersPagination2')"/>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'Leaderboard',
    components: { CButton },
    props: {

    },
    data() {
      return {
        failureMessage: '',
        users: [],
        users2: [],
        usersPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        usersPagination2: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        usersTable: [
          {
            key: 'levelRank',
            label: 'Rank'
          },
          {
            key: 'rider'
          },
          {
            key: 'level'
          },
          {
            key: 'experiencePoints',
            label: 'EXP Points'
          },
        ],
        usersTable2: [
          {
            key: 'leagueRank',
            label: 'Rank'
          },
          {
            key: 'rider'
          },
          {
            key: 'racePoints',
            label: 'Race Points'
          },
        ],
      }
    },
    async created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})

      await this.getUserLevelRanking()
      await this.getUserLeagueRanking()
    },
    mounted() {

    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    watch: {

    },
    methods: {
      async getUserLevelRanking() {
        this.failureMessage = ''
        this.users = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getUserLevelRanking.graphql'),
          variables: {
            page: this.usersPagination.page,
            itemsPerPage: this.usersPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getUserLevelRanking) {
          this.users.push(...result.data.getUserLevelRanking.users)
          this.usersPagination.count = result.data.getUserLevelRanking.pagination.count
          this.usersPagination.totalPages = result.data.getUserLevelRanking.pagination.totalPages

          const userIdToCheck = this.userId ? this.userId : this.user ? this.user.id : undefined
          if (userIdToCheck) {
            for (let i=0; i < this.users.length; i++) {
              const user = this.users[i];
              if (user.id === userIdToCheck) user._rowVariant = 'primary'
            }
          }
        }
      },
      async getUserLeagueRanking() {
        this.failureMessage = ''
        this.users2 = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getUserLeagueRanking.graphql'),
          variables: {
            page: this.usersPagination2.page,
            itemsPerPage: this.usersPagination2.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getUserLeagueRanking) {
          this.users2.push(...result.data.getUserLeagueRanking.users)
          this.usersPagination2.count = result.data.getUserLeagueRanking.pagination.count
          this.usersPagination2.totalPages = result.data.getUserLeagueRanking.pagination.totalPages

          const userIdToCheck = this.userId ? this.userId : this.user ? this.user.id : undefined
          if (userIdToCheck) {
            for (let i=0; i < this.users2.length; i++) {
              const user = this.users2[i];
              if (user.id === userIdToCheck) user._rowVariant = 'primary'
            }
          }
        }
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
    }
  }
</script>

<style scoped>

</style>
